<template>
    <div class="insured-uw-container">
        <!-- ===== TOP ROW: Personal Info & Financial / Deposit ===== -->
        <div class="row g-3 mb-3">

            <!-- Personal Info Card -->
            <div class="col-lg-6">
                <div class="meta-section-box h-100">
                    <div class="meta-section-header">
                        <span class="meta-header-icon meta-header-icon--blue">
                            <i class="bi bi-person-vcard-fill"></i>
                        </span>
                        <h6 class="mb-0 fw-bold meta-header-title">Sığorta olunanın şəxsi məlumatları</h6>
                    </div>
                    <div class="meta-content-body">
                        <div class="meta-row">
                            <span class="meta-label">Tam adı</span>
                            <span class="meta-value fw-bold">{{ data.insuredPer?.name }}</span>
                        </div>
                        <div class="meta-row">
                            <span class="meta-label">FIN</span>
                            <span class="meta-value">
                                <span class="font-monospace fin-chip">{{ data.insuredPer?.pin }}</span>
                            </span>
                        </div>
                        <div class="meta-row">
                            <span class="meta-label">Doğum tarixi</span>
                            <span class="meta-value font-monospace">{{ data.insuredPer?.dob }}</span>
                        </div>
                        <div class="meta-row">
                            <span class="meta-label">Cinsi</span>
                            <span class="meta-value">
                                <span class="meta-chip meta-chip--blue">
                                    <i class="bi bi-gender-male me-1" v-if="data.insuredPer?.sex === 'Kişi'"></i>
                                    <i class="bi bi-gender-female me-1" v-else></i>
                                    {{ data.insuredPer?.sex }}
                                </span>
                            </span>
                        </div>
                        <div class="meta-row">
                            <span class="meta-label">Telefon</span>
                            <span class="meta-value">
                                <a :href="'tel:' + data.insuredPer?.phone" class="phone-meta-link">
                                    <i class="bi bi-telephone me-1"></i>{{ data.insuredPer?.phone }}
                                </a>
                            </span>
                        </div>
                        <div class="meta-row">
                            <span class="meta-label">Email</span>
                            <span class="meta-value">
                                <a :href="'mailto:' + data.insuredPer?.mail" class="phone-meta-link">
                                    <i class="bi bi-envelope me-1"></i>{{ data.insuredPer?.mail }}
                                </a>
                            </span>
                        </div>
                        <div class="meta-row">
                            <span class="meta-label">Boy / Çəki</span>
                            <span class="meta-value d-flex align-items-center gap-2">
                                <span class="meta-chip meta-chip--gray">{{ data.insuredPer?.height }}</span>
                                <span class="meta-chip meta-chip--gray">{{ data.insuredPer?.weight }}</span>
                            </span>
                        </div>
                        <div class="meta-row border-bottom-0">
                            <span class="meta-label">Ünvan</span>
                            <span class="meta-value text-muted" style="line-height: 1.4; text-align: right;">{{ data.insuredPer?.address }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Financials & Deposit -->
            <div class="col-lg-6">
                <!-- Maliyyə Card -->
                <div class="meta-section-box mb-3">
                    <div class="meta-section-header justify-content-between">
                        <div class="d-flex align-items-center gap-2">
                            <span class="meta-header-icon meta-header-icon--green">
                                <i class="bi bi-cash-stack"></i>
                            </span>
                            <h6 class="mb-0 fw-bold meta-header-title">Maliyyə parametrləri</h6>
                        </div>
                        <button type="button" @click="dialogVis = true" class="btn action-btn action-btn--info py-1 px-2" style="font-size: 0.78rem;">
                            <i class="bi bi-pencil-square me-1"></i>
                            <span>Düzəliş</span>
                        </button>
                    </div>
                    <div class="meta-content-body">
                        <div class="meta-row">
                            <span class="meta-label">Bank vergi dərəcəsi</span>
                            <span class="meta-value"><span class="meta-chip meta-chip--amber">{{ data.bankTax }}</span></span>
                        </div>
                        <div class="meta-row">
                            <span class="meta-label">Risk məbləğ</span>
                            <span class="meta-value fw-bold text-danger">{{ data.riskSum }}</span>
                        </div>
                        <div class="meta-row">
                            <span class="meta-label">Məbləğ limiti</span>
                            <span class="meta-value fw-bold">{{ data.sumLimit }}</span>
                        </div>
                        <div class="meta-row">
                            <span class="meta-label">Beta cost</span>
                            <span class="meta-value font-monospace">{{ data.betaCost }}</span>
                        </div>
                        <div class="meta-row">
                            <span class="meta-label">Sığorta məbləği</span>
                            <span class="meta-value fw-bold text-success">{{ data.sumInsured }}</span>
                        </div>
                        <div class="meta-row border-bottom-0">
                            <span class="meta-label">Sığorta haqqı</span>
                            <span class="meta-value fw-bold text-primary">{{ data.premium }}</span>
                        </div>
                    </div>
                </div>

                <!-- Depozit Card -->
                <div class="meta-section-box mb-3">
                    <div class="meta-section-header">
                        <span class="meta-header-icon meta-header-icon--purple">
                            <i class="bi bi-bank2"></i>
                        </span>
                        <h6 class="mb-0 fw-bold meta-header-title">Depozit</h6>
                    </div>
                    <div class="meta-content-body">
                        <div class="meta-row">
                            <span class="meta-label">Depozit hesabı</span>
                            <span class="meta-value font-monospace text-xs" style="font-size: 0.75rem; word-break: break-all; text-align: right;">{{ data.depNumber }}</span>
                        </div>
                        <div class="meta-row border-bottom-0">
                            <span class="meta-label">Depozit dərəcəsi</span>
                            <span class="meta-value d-flex gap-2">
                                <span class="meta-chip meta-chip--blue">{{ data.depRate }}</span>
                                <span class="meta-chip meta-chip--green">Klient: {{ data.depRateClient }}</span>
                            </span>
                        </div>
                    </div>
                </div>

                <!-- Əlavə risklər -->
                <div class="meta-section-box">
                    <div class="meta-section-header">
                        <span class="meta-header-icon meta-header-icon--amber">
                            <i class="bi bi-shield-exclamation"></i>
                        </span>
                        <h6 class="mb-0 fw-bold meta-header-title">Əlavə risklər</h6>
                    </div>
                    <div class="meta-content-body">
                        <div class="meta-row border-bottom-0">
                            <span class="meta-label">Əlillik dərəcələri</span>
                            <span class="meta-value d-flex gap-2">
                                <span class="meta-chip meta-chip--amber">III dərəcə: {{ data.coverDegree3 }}</span>
                                <span class="meta-chip meta-chip--amber">II dərəcə: {{ data.coverDegree2 }}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ===== MEDICAL QUESTIONNAIRE ===== -->
        <div class="row g-3 mb-3">
            <div class="col-12">
                <div class="medical-section-box">
                    <div class="medical-section-header">
                        <span class="meta-header-icon meta-header-icon--red">
                            <i class="bi bi-heart-pulse-fill"></i>
                        </span>
                        <div>
                            <h6 class="mb-0 fw-bold meta-header-title">Sığorta olunanın çəkilmiş xəstəliklərə tutulması</h6>
                            <small class="text-muted" style="font-size: 0.76rem;">Tibbi anket sualları — müştəri tərəfindən cavablandırılıb</small>
                        </div>
                    </div>

                    <div class="medical-qa-list">
                        <div
                            v-for="(item, index) in data2"
                            :key="'q1-' + index"
                            class="medical-qa-row"
                            :class="{ 'qa-checked': item.check === true, 'qa-unchecked': !item.check }"
                        >
                            <div class="qa-indicator">
                                <span v-if="item.check === true" class="qa-badge qa-badge--yes">
                                    <i class="bi bi-check-lg"></i>
                                </span>
                                <span v-else-if="item.check === false" class="qa-badge qa-badge--no">
                                    <i class="bi bi-x-lg"></i>
                                </span>
                                <span v-else class="qa-badge qa-badge--unanswered">
                                    <i class="bi bi-dash"></i>
                                </span>
                            </div>
                            <span class="qa-text">{{ item.descr }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Existing Diagnosed Conditions -->
            <div class="col-12">
                <div class="medical-section-box">
                    <div class="medical-section-header">
                        <span class="meta-header-icon meta-header-icon--red">
                            <i class="bi bi-hospital-fill"></i>
                        </span>
                        <div>
                            <h6 class="mb-0 fw-bold meta-header-title">Sığorta olunanda sadalanan xəstəliklər və ya simptomlar mövcuddur</h6>
                            <small class="text-muted" style="font-size: 0.76rem;">Diaqnostika edilmiş xəstəliklər siyahısı</small>
                        </div>
                    </div>

                    <div class="disease-chips-list p-3">
                        <div
                            v-for="(item, index) in data3"
                            :key="'d-' + index"
                            class="disease-chip-row"
                            :class="{ 'disease-present': item.check === true, 'disease-absent': !item.check }"
                        >
                            <span class="disease-status-icon">
                                <i v-if="item.check" class="bi bi-exclamation-triangle-fill text-warning"></i>
                                <i v-else class="bi bi-check-circle text-success"></i>
                            </span>
                            <span class="disease-text">{{ item.descr }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ===== EDIT MODAL ===== -->
        <el-dialog
            v-model="dialogVis"
            width="520px"
            :close-on-click-modal="false"
            :destroy-on-close="true"
            class="uw-edit-dialog"
        >
            <template #header>
                <div class="uw-dialog-header">
                    <span class="uw-dialog-icon">
                        <i class="bi bi-pencil-square"></i>
                    </span>
                    <div>
                        <div class="fw-bold" style="font-size: 0.95rem;">Sığorta haqqının və parametrlərin dəyişdirilməsi</div>
                        <small class="text-muted" style="font-size: 0.75rem;">Maliyyə göstəricilərini yeniləyin</small>
                    </div>
                </div>
            </template>

            <el-form label-position="top" :model="values" @submit.prevent>
                <div class="row g-2">
                    <div class="col-sm-6">
                        <el-form-item label="Bank vergi dərəcəsi (%)">
                            <el-input type="number" v-model="values.bankTax" />
                        </el-form-item>
                    </div>
                    <div class="col-sm-6">
                        <el-form-item label="Risk məbləğ (AZN)">
                            <el-input type="number" v-model="values.riskSum" />
                        </el-form-item>
                    </div>
                    <div class="col-sm-6">
                        <el-form-item label="Sığorta məbləği (AZN)">
                            <el-input type="number" v-model="values.sumInsured" />
                        </el-form-item>
                    </div>
                    <div class="col-sm-6">
                        <el-form-item label="Sığorta haqqı (AZN)">
                            <el-input type="number" v-model="values.premium" />
                        </el-form-item>
                    </div>
                    <div class="col-sm-6">
                        <el-form-item label="Beta cost">
                            <el-input type="number" v-model="values.betaCost" />
                        </el-form-item>
                    </div>
                    <div class="col-sm-6">
                        <el-form-item label="Sığorta məbləğ limiti">
                            <el-input type="number" v-model="values.sumLimit" />
                        </el-form-item>
                    </div>
                    <div class="col-sm-6">
                        <el-form-item label="Ödəyici haqqı">
                            <el-input type="number" v-model="values.holderPremium" />
                        </el-form-item>
                    </div>
                    <div class="col-sm-6">
                        <el-form-item label="Ödəyici məbləği">
                            <el-input type="number" v-model="values.holderSumInsured" />
                        </el-form-item>
                    </div>
                </div>
            </el-form>

            <template #footer>
                <div class="uw-dialog-footer">
                    <button class="btn action-btn action-btn--muted" @click="dialogVis = false">
                        <i class="bi bi-x-lg me-1"></i>İmtina
                    </button>
                    <button class="btn action-btn action-btn--excel" @click="dialogVis = false">
                        <i class="bi bi-check2 me-1"></i>Daxil et
                    </button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "UnderwritingInsuredData",
    props: {
        data: Object,
        data2: Array,
        data3: Array
    },
    data() {
        return {
            loading: false,
            values: {
                bankTax: 18,
                riskSum: 250000,
                sumInsured: 200000,
                premium: 5500,
                betaCost: 1200,
                sumLimit: 300000,
                holderPremium: 3000,
                holderSumInsured: 150000,
            },
            dialogVis: false
        }
    }
}
</script>

<style scoped lang="scss">
// ---- Shared Section Box ----
.meta-section-box {
    background: var(--app-surface-soft, #f8fafc);
    border: 1px solid var(--app-border, #e2e8f0);
    border-radius: var(--app-radius, 8px);
    overflow: hidden;
}

.meta-section-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    background: var(--app-surface, #ffffff);
    border-bottom: 1px solid var(--app-border, #e2e8f0);
}

.meta-header-icon {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.88rem;
    flex-shrink: 0;

    &--blue { background: rgba(11, 79, 156, 0.12); color: var(--bs-info, #0b4f9c); }
    &--purple { background: rgba(147, 51, 234, 0.12); color: #9333ea; }
    &--green { background: rgba(16, 185, 129, 0.12); color: #059669; }
    &--amber { background: rgba(245, 158, 11, 0.12); color: #d97706; }
    &--red { background: rgba(239, 68, 68, 0.12); color: #dc2626; }
}

.meta-header-title {
    font-size: 0.88rem;
    color: var(--app-heading, #1e293b);
}

.meta-content-body {
    padding: 4px 14px;
}

.meta-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 0;
    border-bottom: 1px solid var(--app-border, #e2e8f0);
    font-size: 0.82rem;
}

.meta-label {
    color: var(--app-text, #64748b);
    font-weight: 550;
    min-width: 150px;
    flex-shrink: 0;
}

.meta-value {
    color: var(--app-heading, #1e293b);
    text-align: right;
    word-break: break-word;
}

// ---- Chips ----
.meta-chip {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 9999px;
    font-size: 0.74rem;
    font-weight: 700;

    &--blue { background: rgba(11, 79, 156, 0.1); color: var(--bs-info, #0b4f9c); }
    &--green { background: rgba(16, 185, 129, 0.12); color: #059669; }
    &--amber { background: rgba(245, 158, 11, 0.14); color: #b45309; }
    &--gray { background: rgba(100, 116, 139, 0.12); color: #475569; font-family: monospace; }
}

.fin-chip {
    padding: 2px 10px;
    border-radius: 6px;
    font-size: 0.8rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    background: rgba(11, 79, 156, 0.1);
    color: var(--bs-info, #0b4f9c);
    border: 1px solid rgba(11, 79, 156, 0.2);
}

.phone-meta-link {
    color: var(--bs-info, #0b4f9c);
    text-decoration: none;
    font-weight: 600;
    &:hover { text-decoration: underline; }
}

// ---- Medical Questionnaire ----
.medical-section-box {
    background: var(--app-surface, #ffffff);
    border: 1px solid var(--app-border, #e2e8f0);
    border-radius: var(--app-radius, 8px);
    overflow: hidden;
}

.medical-section-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    background: var(--app-surface-soft, #f8fafc);
    border-bottom: 1px solid var(--app-border, #e2e8f0);
}

.medical-qa-list {
    padding: 8px 16px;
}

.medical-qa-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 10px 0;
    border-bottom: 1px solid var(--app-border, #f1f5f9);
    font-size: 0.83rem;
    line-height: 1.45;

    &:last-child { border-bottom: none; }
    &.qa-checked .qa-text { color: var(--app-heading, #1e293b); font-weight: 550; }
    &.qa-unchecked .qa-text { color: var(--app-text, #64748b); }
}

.qa-indicator { flex-shrink: 0; margin-top: 1px; }

.qa-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    font-size: 0.75rem;
    font-weight: 800;

    &--yes { background: rgba(16, 185, 129, 0.18); color: #059669; border: 1.5px solid rgba(16, 185, 129, 0.45); }
    &--no { background: rgba(239, 68, 68, 0.12); color: #dc2626; border: 1.5px solid rgba(239, 68, 68, 0.35); }
    &--unanswered { background: rgba(100, 116, 139, 0.12); color: #64748b; border: 1.5px solid rgba(100, 116, 139, 0.3); }
}

.qa-text { flex: 1; }

// ---- Disease Chips ----
.disease-chips-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.disease-chip-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 0.82rem;
    border: 1px solid transparent;

    &.disease-present {
        background: rgba(245, 158, 11, 0.08);
        border-color: rgba(245, 158, 11, 0.3);
        .disease-text { font-weight: 600; color: #92400e; }
    }

    &.disease-absent {
        background: rgba(100, 116, 139, 0.05);
        border-color: transparent;
        .disease-text { color: var(--app-text, #64748b); }
    }
}

.disease-status-icon { font-size: 0.9rem; flex-shrink: 0; }

// ---- Modal / Dialog ----
.uw-dialog-header {
    display: flex;
    align-items: center;
    gap: 12px;
}

.uw-dialog-icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: rgba(11, 79, 156, 0.12);
    color: var(--bs-info, #0b4f9c);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    flex-shrink: 0;
}

.uw-dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}

// ---- Dark Mode ----
[data-theme="dark"] {
    .meta-section-box { background: #141b22; border-color: #283544; }
    .meta-section-header { background: #182029; border-color: #283544; }
    .meta-header-title { color: #f1f5f9; }
    .meta-row { border-color: #242f3d; }
    .meta-label { color: #94a3b8; }
    .meta-value { color: #f1f5f9; }
    .fin-chip { background: rgba(59, 130, 246, 0.2); color: #93c5fd; border-color: rgba(59, 130, 246, 0.35); }
    .phone-meta-link { color: #93c5fd; }
    .meta-chip--gray { background: rgba(255, 255, 255, 0.1); color: #cbd5e1; }

    .medical-section-box { background: #182029; border-color: #283544; }
    .medical-section-header { background: #141b22; border-color: #283544; }
    .medical-qa-row {
        border-color: #242f3d;
        &.qa-checked .qa-text { color: #f1f5f9; }
        &.qa-unchecked .qa-text { color: #94a3b8; }
    }
    .qa-badge {
        &--yes { background: rgba(16, 185, 129, 0.2); color: #34d399; border-color: rgba(52, 211, 153, 0.4); }
        &--no { background: rgba(239, 68, 68, 0.2); color: #fca5a5; border-color: rgba(248, 113, 113, 0.4); }
    }
    .disease-chip-row {
        &.disease-present {
            background: rgba(245, 158, 11, 0.12);
            border-color: rgba(245, 158, 11, 0.4);
            .disease-text { color: #fbbf24; }
        }
        &.disease-absent .disease-text { color: #94a3b8; }
    }
}
</style>